import log from '../../log';
import createUpdateState from './createUpdateState';
import createUpdateContext from './createUpdateContext';
import createUpdateProperties from './createUpdateProperties';
import createDispatch from './createDispatch';

export default function createHelpers(host, propertyDefs, executionTiming = null, options = {}) {
	const wrappedDispatch = createDispatch(host, executionTiming);
	const dispatch = (...args) => {
		log(
			`Please update the view for ${host.tagName.toLowerCase()} from using dispatch as the second argument to an object with dispatch, updateState, and updateProperties`,
			{host, origin: 'createHelpers'}
		);
		wrappedDispatch(...args);
	};

	if (options.presentational) return {dispatch: wrappedDispatch};

	dispatch.dispatch = wrappedDispatch;
	dispatch.updateState = createUpdateState(host, executionTiming);
	dispatch.updateProperties = createUpdateProperties(host, propertyDefs, executionTiming);
	dispatch.updateContext = createUpdateContext(host, executionTiming);
	return dispatch;
}
